import type { RouteProps } from 'react-router-dom'

import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { generatePath, Redirect, Route } from 'react-router-dom'
import AppLoader from '@components/common/AppLoader'

export interface BrandBasedRouteProps extends RouteProps {}

const BrandBasedRoute: React.FC<BrandBasedRouteProps> = ({
  path,
  exact,
  children
}) => {
  const { currentBrand } = usePartner()

  // Guard: ждём пока бренд не будет определён
  if (!currentBrand?.slug) {
    return <AppLoader content="Загрузка бренда..." />
  }

  const brandSlug = currentBrand.slug

  return (
    <Route path={path} exact={exact}>
      {({ match }) => {
        if (match?.path && brandSlug !== match?.params.brandSlug) {
          return <Redirect to={generatePath(match.path, { brandSlug })} />
        }

        return <>{children}</>
      }}
    </Route>
  )
}

export default BrandBasedRoute
